(() => {
  const products = Array.isArray(window.hidePriceProducts)
    ? window.hidePriceProducts
    : [];

  const hiddenHandles = new Set(
    products
      .map((product) => product.handle?.trim().toLowerCase())
      .filter(Boolean)
  );

  const hiddenTitles = new Set(
    products
      .map((product) => product.title?.trim().toLowerCase())
      .filter(Boolean)
  );

  function getProductHandle(url) {
    if (!url || !url.includes('/products/')) {
      return '';
    }

    return url
      .split('/products/')[1]
      .split('?')[0]
      .split('#')[0]
      .replace(/\/$/, '')
      .trim()
      .toLowerCase();
  }

function hideConvermaxCardPrices() {
  document.querySelectorAll('.cm_product-item').forEach((card) => {
    const productLink = card.querySelector('a[href*="/products/"]');
    const handle = getProductHandle(productLink?.getAttribute('href'));

    if (!handle || !hiddenHandles.has(handle)) {
      return;
    }

    const priceContainer = card.querySelector(
      '.cm_product-item__price-container'
    );

    if (!priceContainer) {
      return;
    }

    priceContainer.classList.add('hide-price-container');
    priceContainer.innerHTML = `
      <span class="hide-price-notice">
        Contact for Pricing
      </span>
    `;
  });
}

  function hidePredictiveSearchPrices() {
    document
      .querySelectorAll('.cmTemplate_product.product-item')
      .forEach((item) => {
        const title = item
          .querySelector('.title')
          ?.textContent
          .trim()
          .toLowerCase();

        if (!title || !hiddenTitles.has(title)) {
          return;
        }

        item
          .querySelector('.price')
          ?.style.setProperty('display', 'none', 'important');
      });
  }

  function hidePrices() {
    hideConvermaxCardPrices();
    hidePredictiveSearchPrices();
  }

  let scheduled = false;

  function scheduleHidePrices() {
    if (scheduled) {
      return;
    }

    scheduled = true;

    window.requestAnimationFrame(() => {
      hidePrices();
      scheduled = false;
    });
  }

  hidePrices();

  const observer = new MutationObserver(scheduleHidePrices);

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();